import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DetailedResultDto } from 'src/app/core/classes/detailed-result-dto';
import { LinkedAccounts } from 'src/app/core/interfaces/loggedInUserDto';
import { Option } from 'src/app/core/interfaces/options-dynamicform';
import { StepFormConfig } from 'src/app/core/interfaces/stepper-form-config';

import { DoctorsDayDetailsDto } from 'src/app/core/classes/doctorsDayDetailsDto';

@Injectable({
  providedIn: 'root'
})
export class BroadcastService {

  public handler: Subject<any> = new Subject<any>();
  private detailedResultDto = new BehaviorSubject<DetailedResultDto>(new DetailedResultDto());
  public billingMethod = new BehaviorSubject<LinkedAccounts>(new LinkedAccounts());
  public enabledAccountCodes: Subject<string[]> = new Subject<string[]>();
  public selectedAccounts: Subject<string[]> = new Subject<string[]>();
  public selectedCollectedOnDateRange: Subject<any> = new Subject<any>();
  public doctorsDayDetails= new BehaviorSubject<DoctorsDayDetailsDto>(new DoctorsDayDetailsDto());
  public accountSelected = new BehaviorSubject<string>('');
  public linkPageActive = new BehaviorSubject<any>(null);
  public dropdownOption: Option[];
  private configsubject = new Subject<StepFormConfig>();
  public setinitialQuestionaire = new Array();
  public navLinksRefCollection = new Array();
  public idbasicToken: string;
  constructor(@Inject(DOCUMENT) private bodyDocument: HTMLDocument) { }

  setIdbasicToken(idToken: string) {
    this.idbasicToken = idToken;
  }

  getIdbasicToken() {
    return this.idbasicToken;
  }

  setLinkUserActive(event: any) {
    this.linkPageActive.next(event);
  }

  broadcast(type: string, payload: any = null) {
    this.handler.next({ type, payload });
  }

  subscribe(): Observable<any> {
    return this.handler.asObservable();
  }

  setDetailedResultDTO(detailedResultDto: DetailedResultDto) {
    this.detailedResultDto.next(detailedResultDto);
  }

  setDoctorDayDetailsDTO(doctorsDayDetails: DoctorsDayDetailsDto) {
    this.doctorsDayDetails.next(doctorsDayDetails);
  }

  getDoctorDayDetailsDto() {
    return this.doctorsDayDetails;
  }

  accountSelectBroadcast(accountString: string) {
    this.accountSelected.next(accountString);
  }

  getAccountSelectBroadcast() {
    return this.accountSelected;
  }


  getDetailedResultDTO() {
    return this.detailedResultDto;
  }

  setEnabledAccountCodes(accountCodes: string[]) {
    this.enabledAccountCodes.next(accountCodes);
  }

  getEnabledAccountCodes() {
    return this.enabledAccountCodes;
  }

  setSelectedAccount(selectedAccountValue: string[]) {
    this.selectedAccounts.next(selectedAccountValue);
  }

  getSelectedAccount() {
    return this.selectedAccounts;
  }
  setCollectedOnDateRange(selectedValue: any) {
    this.selectedCollectedOnDateRange.next(selectedValue);
  }
  getCollectedOnDateRange() {
    return this.selectedCollectedOnDateRange;
  }
  setIdFromDynamicformMassComplete(value) {
    this.dropdownOption = value;
  }
  getIdFromDynamicFormMassComplete() {
    return this.dropdownOption;
  }

  setConfigarationChange(config: StepFormConfig) {
    this.configsubject.next(config);
  }
  getConfigarationChange(): Observable<any> {
    return this.configsubject.asObservable();
  }
  setQuestionDataResponse(value) {
    this.setinitialQuestionaire = value;
  }
  getQuestionDataResponse() {
    return this.setinitialQuestionaire;
  }

  setNavLinksRef(hoverLink?, index?) {
    if (hoverLink) {
      this.navLinksRefCollection.push({ ref: hoverLink, indexOfRef: index });
    } else {
      this.navLinksRefCollection = [];
    }
  }

  getNavLinksRef() {
    return this.navLinksRefCollection;
  }

  onOpen() {
    const element: any = this.bodyDocument.querySelectorAll('.mat-drawer-inner-container')[0];
    element.style.overflowY = 'hidden';
  }

  onClose() {
    const element: any = this.bodyDocument.querySelectorAll('.mat-drawer-inner-container')[0];
    element.style.overflow = 'auto';
  }


  onOpenDropDownOrderForm() {
    const element: any = this.bodyDocument.querySelectorAll('app-order-form')[0];
    setTimeout(() => {
       element.style.overflowY = 'hidden';
      }, 100);
  }


  onCloseDropDownOrderForm() {
    const element: any = this.bodyDocument.querySelectorAll('app-order-form')[0];
    element.style.overflowY = 'auto';
  }

  freezeBulkUploadOrderUI() {
    const element: any = this.bodyDocument.querySelectorAll('body.clindx-theme')[0];
    element.style.overflowY = 'hidden';
  }

  unFreezeBulkUploadOrderUI() {
    const element: any = this.bodyDocument.querySelectorAll('body.clindx-theme')[0];
    element.style.overflowY = 'auto';
  }

  freezeScreenDropDownOpen() {
    const element: any = this.bodyDocument.querySelectorAll('.mat-drawer-content')[1];
    element.style.overflowY = 'hidden';
  }

  unFreezeScreenDropDownClose() {
    const element: any = this.bodyDocument.querySelectorAll('.mat-drawer-content')[1];
    element.style.overflowY = 'auto';
  }
}
